<template>
    <div>
        <multi-select
            :options="options"
            :multiple="false"
            v-model="object"
            class="w-60"
            :id="fieldName"
            track-by="id"
            :name="fieldName"
            searchable
            label="name"
        />
        <div v-if="error" class="mt-3">
            <error :error="error" />
        </div>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import reference from "../mixins/reference";
import MultiSelect from "vue-multiselect";
import siteLanguage from '../config/siteLanguage'
export default {
    name: "ReferenceSelect",
    components: { MultiSelect },
    mixins: [reference],
    props: {
        fieldName: String,
        value: Number,
        modelData: String,
        language: {
            type: Object,
            default: () => {
                return { id: siteLanguage.language.ENGLISH, iso: siteLanguage.iso.ENGLISH };
            },
        },
        error: {
            type: String,
            required: false,
        },
        excludedIds: Array,
        query: Object,
        order: Object,
    },
    data() {
        return {
            model: this.modelData || null,
            object: null,
            options: [],
            optionsRetrieved: false,
        };
    },
    async created() {
        const { data } = await axios.get(this.scopedListRoute).catch((err) => {
            console.error(err.response || err);
        });
        this.options = data.data;
        this.optionsRetrieved = true;

        if (this.value && typeof this.value === "number") {
            let optionObject = this.options.filter((obj) => {
                return obj.id === this.value;
            });

            this.object = optionObject[0] ?? null;
        }
    },
    computed: {
        scopedListRoute() {
            let listRoute = this.contentTypes[this.model]
                ? this.contentTypes[this.model].listRoute
                : "";
            let route = listRoute + "?";
            if (this.language)
                route += `language=${this.language.id}`;
            if (this.excludedIds && this.excludedIds?.length > 0)
                route += "&excluded=" + (this.excludedIds || []).join(",");
            if (this.query) {
                route += `&query=${JSON.stringify(this.query)}`;
            }
            if (this.order) {
                route += `&order=${JSON.stringify(this.order)}`;
            }
            return route;
        },
    },
    watch: {
        object(newValue) {
            this.$emit("input", newValue ? newValue.id : null);
        },
    },
};
</script>
